import { render, staticRenderFns } from "./BaseDetailItem.vue?vue&type=template&id=1eef8070&scoped=true"
import script from "./BaseDetailItem.vue?vue&type=script&lang=js"
export * from "./BaseDetailItem.vue?vue&type=script&lang=js"
import style0 from "./BaseDetailItem.vue?vue&type=style&index=0&id=1eef8070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eef8070",
  null
  
)

export default component.exports